var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.375 8.12788C13.375 7.73079 13.3394 7.34897 13.2732 6.98242H7.99902V9.1486H11.0128C10.883 9.8486 10.4885 10.4417 9.89539 10.8388V12.2439H11.7052C12.7641 11.269 13.375 9.83333 13.375 8.12788Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99948 13.6005C9.51148 13.6005 10.7791 13.099 11.7057 12.2437L9.89585 10.8386C9.39439 11.1746 8.75294 11.3732 7.99948 11.3732C6.54094 11.3732 5.30639 10.3881 4.86603 9.06445H2.99512V10.5154C3.91657 12.3455 5.81039 13.6005 7.99948 13.6005Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86596 9.06524C4.75396 8.72924 4.69032 8.37033 4.69032 8.00124C4.69032 7.63215 4.75396 7.27324 4.86596 6.93724V5.48633H2.99505C2.61578 6.24233 2.39941 7.0976 2.39941 8.00124C2.39941 8.90487 2.61578 9.76015 2.99505 10.5161L4.86596 9.06524Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99948 4.62766C8.82166 4.62766 9.55984 4.91021 10.1402 5.46512L11.7464 3.85894C10.7766 2.9553 9.50894 2.40039 7.99948 2.40039C5.81039 2.40039 3.91657 3.6553 2.99512 5.48548L4.86603 6.93639C5.30639 5.61275 6.54094 4.62766 7.99948 4.62766Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.48c0cfd2.svg";
export { ForwardRef as ReactComponent };